<section id="hero" class="scroll-mt-24">
<app-services-hero-section></app-services-hero-section>
</section>

<section id="details" class="scroll-mt-24">
<app-services-details-section></app-services-details-section>
</section>


<section id="details" class="scroll-mt-24">
  <app-services-cta-section></app-services-cta-section>
</section>
